module.exports = __webpack_public_path__ + "assets/img/1811589512665_.pic_hd.f1c625ad.jpg";